import React, { forwardRef } from 'react';
import { Check } from 'lucide-react';
import './Checkbox.scss';

const cx = (...classes) => classes.filter(Boolean).join(' ');

const Checkbox = forwardRef(({
  label,
  size = 'sm',
  className = '',
  disabled,
  ...props
}, ref) => (
  <label className={cx('reops-checkbox', `reops-checkbox--${size}`, disabled && 'is-disabled', className)}>
    <input
      ref={ref}
      type="checkbox"
      className="reops-checkbox__input"
      disabled={disabled}
      {...props}
    />
    <span className="reops-checkbox__box" aria-hidden="true">
      <Check className="reops-checkbox__check" strokeWidth={2.4} />
    </span>
    {label ? <span className="reops-checkbox__label">{label}</span> : null}
  </label>
));

Checkbox.displayName = 'Checkbox';

export default Checkbox;
